/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_2FA_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_FORGOT,
  AUTH_RESET,
  AUTH_VALIDATE_RESET_TOKEN,
  AUTH_SET_SUCCESS,
  AUTH_SESSION_KEEPALIVE,
  AUTH_CLEAR_TOKEN,
  AUTH_SET_ACCOUNT_TOKEN, AUTH_2FA_RESEND_REQUEST
} from '../actions/auth'
import apiCall from './call'
import { ToastProgrammatic as Toast } from 'buefy'

const state = {
  authenticatedToken: localStorage.getItem('authenticatedToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  status: '',
  fromShareLink: localStorage.getItem('fromShareLink') === 'true' || false
}

const getters = {
  isAuthenticated: state => !!state.authenticatedToken,
  authToken: state => state.authenticatedToken,
  isFromShareLink: state => state.fromShareLink
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      apiCall({ url: 'login', data: user, method: 'POST' })
        .then(response => {
          if (response.hasOwnProperty('data')) {
            response = response.data
          }
          commit(AUTH_SUCCESS, response)
          commit('isLoading', { root: true })
          if (user.hasOwnProperty('email')) {
            sessionStorage.setItem('email', user.email)
          }
          resolve(response)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          commit('resetState', { root: true })
          commit('doneLoading', { root: true })
          reject(err)
        })
    })
  },
  [AUTH_2FA_REQUEST]: ({ commit, dispatch }, authCode) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'two-factor-challenge', data: authCode, method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          commit('doneLoading', { root: true })
          reject(err)
        })
    })
  },
  [AUTH_2FA_RESEND_REQUEST]: ({ commit, dispatch }, authCode) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'reset-two-factor-challenge', method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          commit('doneLoading', { root: true })
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'logout' })
        .then(response => {
          Toast.open({
            duration: 2000,
            message: response.message,
            position: 'is-top',
            type: 'is-success',
            queue: false
          })
          resolve(response)
        })
        .catch(err => {
          if (err.response !== undefined) {
            console.error('Logout Attempted: ' + err.response.data.message)
          }

          reject(err)
        })

      commit(AUTH_LOGOUT)
      commit('resetState', { root: true })
      commit('doneLoading', { root: true })
    })
  },
  [AUTH_FORGOT]: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'password/create', data: email, method: 'POST' })
        .then(response => {
          commit(AUTH_LOGOUT, response)
          sessionStorage.setItem('email', email.email)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [AUTH_RESET]: ({ commit, dispatch }, formData) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'password/reset', data: formData, method: 'POST' })
        .then(response => {
          commit(AUTH_LOGOUT, response)
          sessionStorage.setItem('email', formData.email)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [AUTH_VALIDATE_RESET_TOKEN]: ({ commit, dispatch }, resetToken) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'password/find/' + resetToken })
        .then(response => {
          if (response.response === 'success') {
            commit(AUTH_LOGOUT, response)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [AUTH_SET_SUCCESS]: ({ commit }, response) => {
    commit(AUTH_SUCCESS, response)
  },
  [AUTH_SESSION_KEEPALIVE]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: 'token/keep',
        method: 'POST'
      }).then(response => {
        commit('hideTimeoutModal')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  [AUTH_CLEAR_TOKEN]: ({ commit }) => {
    commit(AUTH_LOGOUT)
    commit('resetState', { root: true })
    commit('doneLoading', { root: true })
  },
  [AUTH_SET_ACCOUNT_TOKEN]: ({ commit }, accountToken) => {
    commit(AUTH_SUCCESS, {
      token: accountToken,
      fromShareLink: true
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    if (resp.refresh_token !== undefined) {
      state.refreshToken = resp.refresh_token
      localStorage.setItem('refreshToken', resp.refresh_token)
    }
    if (resp.token !== undefined) {
      state.authenticatedToken = resp.token
      localStorage.setItem('authenticatedToken', resp.token)
    }
    if (resp.fromShareLink !== undefined) {
      state.fromShareLink = resp.fromShareLink
      localStorage.setItem('fromShareLink', resp.fromShareLink)
    }
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.authenticatedToken = ''
    state.refreshToken = ''
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('authenticatedToken')
    localStorage.removeItem('fromShareLink')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js